import { getBaseStore } from './BaseStore';
import { getEnvironment } from './utils/utils';
import { DutyExchange } from './models/DutyExchange';
import { flow, getRoot, Instance, types } from 'mobx-state-tree';
import { RootStore } from './RootStore';
import NotificationToast from '../components/common/NotificationToast';
import moment from 'moment';
import { ApiFetcherImpl } from '../api';

export const DutyExchangeStore = types
  .compose(
    getBaseStore<Instance<typeof DutyExchange>, Instance<typeof DutyExchange>>(
      DutyExchange,
      'dutyExchangeId',
      'dutyExchange',
    ),
    types.model('DutyExchangeStore', {}),
  )
  .actions((self) => {
    const env = getEnvironment(self);
    const root = getRoot(self) as Instance<typeof RootStore>;

    const loadPharmacyDuties = flow(function*(pharmacyId: number) {
      const criteria = {
        pharmacyId,
        NotAssigned: false,
        startDate: moment().format(),
      };
      const result = yield Promise.all([
        root.DutyAssignmentStore!.searchAssignment(criteria),
        root.PharmacyStore!.searchForDutyAssignment(criteria),
        root.DutyStore!.searchForDutyAssignment(criteria),
      ])
        .catch((e) => console.error(e))
        .then((responses) => {
          console.log(responses[0]);
          return responses[0];
        });

      return result;
    });

    const isInConflict = flow(function*(dutyAssignmentId: number, targetPharmacyId: number) {
      const duties = [dutyAssignmentId];
      const hasConflicts = yield env.api.post('dutyExchange/detectConflicts/' + targetPharmacyId, duties);
      return hasConflicts;
    });

    const saveDutyExchange = flow(function*(
      dutyExchange: Instance<typeof DutyExchange>,
      requestorDuties: any,
      neighborDuties: any,
    ) {
      try {
        const neighborId = dutyExchange.recipientId;
        const result = yield env.api.post('dutyExchange', dutyExchange);
        const result2 = yield env.api.post('dutyExchange/' + result! + '/recipient/' + neighborId, requestorDuties);
        const result3 = yield env.api.post('dutyExchange/' + result! + '/requestor/' + neighborId, neighborDuties);
        const result4 = yield env.api.post('dutyExchange/' + result! + '/notifications', {});
        NotificationToast.showSuccess('Data saved successfully');
        return true;
      } catch (e) {
        NotificationToast.showError('Error while saving data');
        return false;
      }
    });

    const downloadLatestExchanges = flow(function*() {
      console.log('download latest exchanges');
      const result = yield env.api.get('DutyExchange/downloadExchangesForWebGarde', {
        responseType: 'blob',
      });
      if (result != null) {
        if ((result as Blob).size > 125) {
          // window.open(result.file);
          const url = window.URL.createObjectURL(new Blob([result]));
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', 'PharmagardeToWebGardeExchanges-' + new Date().toISOString() + '.csv'); //or any other extension
          document.body.appendChild(link);
          link.click();
          return false;
        } else {
          return true;
        }
      }
    });

    return {
      loadPharmacyDuties,
      saveDutyExchange,
      downloadLatestExchanges,
      isInConflict,
    };
  });
